import React, { useState } from 'react';
import { Shield, Users, Award, Clock, Phone, ArrowRight, CheckCircle2, Star, TrendingUp, Baby, Wallet, HeartPulse, Globe, HelpCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { licPlans, hdfcPlans } from '../lib/policiesData';
import SEOHead, { ADVISOR_PHONE, ADVISOR_PHONE_DISPLAY } from '../components/SEOHead';
import { trackWhatsAppClick, trackPhoneClick } from '../services/analytics';

const claimsData = [
  { name: "Suresh***", policy: "LIC Jeevan Anand", policyTe: "ఎల్‌ఐసి జీవన్ ఆనంద్", amountEn: "₹10,00,000 Settled", amountTe: "₹10,00,000 క్లెయిమ్ పరిష్కారం" },
  { name: "Ramesh***", policy: "HDFC ERGO Optima Restore", policyTe: "హెచ్‌డిఎఫ్‌సి ఎర్గో ఆప్టిమా రిస్టోర్", amountEn: "₹5,00,000 Settled", amountTe: "₹5,00,000 క్లెయిమ్ పరిష్కారం" },
  { name: "Priya***", policy: "LIC Jeevan Umang", policyTe: "ఎల్‌ఐసి జీవన్ ఉమాంగ్", amountEn: "₹20,00,000 Settled", amountTe: "₹20,00,000 క్లెయిమ్ పరిష్కారం" },
  { name: "Anil***", policy: "HDFC ERGO my:health Suraksha", policyTe: "హెచ్‌డిఎఫ్‌సి ఎర్గో మై:హెల్త్ సురక్ష", amountEn: "₹15,00,000 Settled", amountTe: "₹15,00,000 క్లెయిమ్ పరిష్కారం" },
  { name: "Kavitha***", policy: "LIC Jeevan Lakshya", policyTe: "ఎల్‌ఐసి జీవన్ లక్ష్య", amountEn: "₹8,00,000 Settled", amountTe: "₹8,00,000 క్లెయిమ్ పరిష్కారం" },
  { name: "Vikram***", policy: "HDFC ERGO Optima Secure", policyTe: "హెచ్‌డిఎఫ్‌సి ఎర్గో ఆప్టిమా సెక్యూర్", amountEn: "₹12,00,000 Settled", amountTe: "₹12,00,000 క్లెయిమ్ పరిష్కారం" },
  { name: "Neha***", policy: "LIC Bima Jyoti", policyTe: "ఎల్‌ఐసి బీమా జ్యోతి", amountEn: "₹5,50,000 Settled", amountTe: "₹5,50,000 క్లెయిమ్ పరిష్కారం" },
];

const homeFaqsEn = [
  {
    q: "Who is V. S. Reddy and what insurance services are provided?",
    a: "V. S. Reddy is a veteran insurance professional with 25+ years of verified advisory experience (since 2000) based in Hyderabad, India. Operating under SVR LIC Services, he provides certified guidance on Life Insurance Corporation of India (LIC) life, child, and pension policies, as well as HDFC ERGO comprehensive health insurance for resident families and global NRIs."
  },
  {
    q: "Can Non-Resident Indians (NRIs) purchase LIC insurance without traveling to India?",
    a: "Yes. Under LIC's Mail Order Business (MOB) procedure, NRIs living across the USA, UAE, UK, Singapore, Canada, and Gulf nations can complete the entire application, KYC attestation, and payment via NRE/NRO accounts without flying to India."
  },
  {
    q: "What makes LIC Jeevan Utsav unique for retirement planning?",
    a: "LIC Jeevan Utsav (Plan 871) offers a contractual 10% annual guaranteed income for life on the Basic Sum Assured after the premium payment term ends, with coverage continuing up to age 100, backed 100% by the sovereign guarantee of the Government of India."
  },
  {
    q: "Does HDFC ERGO Optima Secure cover hospital non-medical consumables?",
    a: "Yes. With its signature Protect Benefit, HDFC ERGO Optima Secure covers 100% of the 68 non-medical consumable items (such as gloves, PPE kits, sanitizers, and syringes) that standard health policies reject, ensuring near-zero out-of-pocket bills."
  },
  {
    q: "How do I schedule a doorstep or digital consultation with V. S. Reddy?",
    a: "You can call or WhatsApp +91-9849664800 directly, or submit a request on our Contact page. Doorstep visits are available across Hyderabad and Secunderabad, while video/phone consultations are held for clients across India and abroad."
  }
];

const homeFaqsTe = [
  {
    q: "వి. ఎస్. రెడ్డి గారు ఎవరు? వారు ఏ సేవలు అందిస్తారు?",
    a: "వి. ఎస్. రెడ్డి గారు హైదరాబాద్ కేంద్రంగా 25 సంవత్సరాలకు పైగా (2000 నుండి) అనుభవం కలిగిన సీనియర్ ఇన్సూరెన్స్ అడ్వైజర్. ఎస్‌విఆర్ ఎల్‌ఐసి సర్వీసెస్ ఆధ్వర్యంలో కేంద్ర ప్రభుత్వ ఎల్‌ఐసి జీవిత బీమా, పిల్లల చదువుల పాలసీలు, రిటైర్‌మెంట్ పెన్షన్ ప్లాన్లు మరియు హెచ్‌డిఎఫ్‌సి ఎర్గో సమగ్ర ఆరోగ్య బీమాపై నిపుణుల సలహాలు అందిస్తారు."
  },
  {
    q: "విదేశాల్లో ఉన్న ఎన్‌ఆర్‌ఐ (NRI)లు భారత్‌కు రాకుండానే ఎల్‌ఐసి పాలసీ తీసుకోవచ్చా?",
    a: "అవును. ఎల్‌ఐసి అధికారిక మెయిల్ ఆర్డర్ బిజినెస్ (MOB) విధానం ద్వారా అమెరికా, దుబాయ్/యూఏఈ, లండన్, సింగపూర్ వంటి దేశాల్లో ఉన్న ఎన్‌ఆర్‌ఐలు భారత్‌కు రాకుండానే ఎన్‌ఆర్‌ఈ/ఎన్‌ఆర్‌ఓ ఖాతాల ద్వారా ఆన్‌లైన్‌లో సురక్షితంగా పాలసీ తీసుకోవచ్చు."
  },
  {
    q: "రిటైర్‌మెంట్ పెన్షన్ కోసం ఎల్‌ఐసి జీవన్ ఉత్సవ్ ఎందుకు అత్యుత్తమమైనది?",
    a: "ఎల్‌ఐసి జీవన్ ఉత్సవ్ (ప్లాన్ 871) ప్రీమియం చెల్లింపు కాలం పూర్తయిన తర్వాత జీవితాంతం 100 ఏళ్ల వరకు ప్రతి సంవత్సరం బేసిక్ సమ్ అష్యూర్డ్‌పై 10% హామీతో కూడిన స్థిరమైన వార్షిక ఆదాయాన్ని అందిస్తుంది. ఇది 100% కేంద్ర ప్రభుత్వ సార్వభౌమ హామీతో రక్షించబడింది."
  },
  {
    q: "హెచ్‌డిఎఫ్‌సి ఎర్గో ఆప్టిమా సెక్యూర్‌లో ఆసుపత్రి కన్స్యూమబుల్స్ కవర్ అవుతాయా?",
    a: "అవును. ఆప్టిమా సెక్యూర్‌లోని ప్రొటెక్ట్ బెనిఫిట్ ద్వారా సాధారణంగా ఇతర పాలసీలు తిరస్కరించే గ్లౌజులు, పీపీఈ కిట్లు, సిరంజీలు వంటి 68 రకాల నాన్-మెడికల్ వస్తువుల బిల్లులను 100% చెల్లిస్తుంది. దీనివల్ల జేబు నుండి అదనపు ఖర్చులు ఉండవు."
  },
  {
    q: "వి. ఎస్. రెడ్డి గారితో ఉచిత సలహా ఎలా పొందవచ్చు?",
    a: "మీరు నేరుగా +91-9849664800 నంబర్‌కు కాల్ లేదా వాట్సాప్ చేయవచ్చు. హైదరాబాద్ మరియు సికింద్రాబాద్ పరిధిలో ఇంటి వద్దకే వచ్చి సలహాలు అందిస్తారు; దేశంలోని ఇతర ప్రాంతాలు మరియు విదేశీ ఎన్‌ఆర్‌ఐలకు ఫోన్ లేదా వీడియో కాల్ ద్వారా సేవలు లభిస్తాయి."
  }
];

const Home = () => {
  const { t, i18n } = useTranslation();
  const isTe = i18n.language === 'te';
  const [activeCategory, setActiveCategory] = useState('protect_family');

  const categories = [
    { id: 'protect_family', label: t('protect_family') },
    { id: 'wealth_creation', label: t('wealth_creation') },
    { id: 'children_future', label: t('children_future') },
    { id: 'retirement_planning', label: t('retirement_planning') },
  ];

  const currentFaqs = isTe ? homeFaqsTe : homeFaqsEn;

  const filteredLICPlans = licPlans.filter(plan => plan.category === activeCategory).slice(0, 3);
  const displayLICPlans = filteredLICPlans.length > 0 ? filteredLICPlans : licPlans.slice(0, 3);

  // Home FAQ schema
  const homeSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': homeFaqsEn.map(faq => ({
      '@type': 'Question',
      'name': faq.q,
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': faq.a
      }
    }))
  };

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950 overflow-hidden">
      <SEOHead
        title={isTe ? "భారతదేశంలో ఎల్‌ఐసి & హెల్త్ ఇన్సూరెన్స్ అడ్వైజర్ | వి. ఎస్. రెడ్డి | VSR Insurance Plus" : "LIC & Insurance Advisor in India | V. S. Reddy | VSR Insurance Plus"}
        description={isTe ? "హైదరాబాద్ మరియు భారత్‌లో 25+ సంవత్సరాల అనుభవం గల సీనియర్ అడ్వైజర్ వి. ఎస్. రెడ్డి గారితో ఎల్‌ఐసి జీవిత బీమా, పిల్లల చదువుల పాలసీలు, రిటైర్‌మెంట్ పెన్షన్ మరియు హెచ్‌డిఎఫ్‌సి ఎర్గో ఆరోగ్య బీమా వివరాలు పొందండి." : "Explore LIC life insurance, child plans, pension options and health insurance with V. S. Reddy, an insurance professional with 25+ years of experience in Hyderabad & across India."}
        canonicalPath="/"
        schemaJson={homeSchema}
      />

      {/* Hero Section */}
      <section className="relative pt-32 pb-16 lg:pt-36 lg:pb-24 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <div className="absolute top-0 right-0 w-[50rem] h-[50rem] bg-gradient-to-br from-primary/20 to-blue-300/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" />
          <div className="absolute bottom-0 left-0 w-[40rem] h-[40rem] bg-gradient-to-tr from-sky-400/10 to-indigo-500/10 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4" />
        </div>

        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/60 dark:bg-slate-800/60 border border-slate-200 dark:border-slate-700 shadow-sm mb-8">
              <span className="flex h-2 w-2 rounded-full bg-emerald-500"></span>
              <span className="text-sm font-semibold text-slate-700 dark:text-slate-300">
                {isTe ? "2000 నుండి విశ్వసనీయ సేవలు • 25+ సంవత్సరాల అనుభవం" : "Trusted Guidance Since 2000 • 25+ Years Verified Expertise"}
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-slate-900 dark:text-white leading-[1.15] tracking-tight mb-6">
              {isTe ? (
                <>
                  భారతదేశంలో విశ్వసనీయ ఎల్‌ఐసి & హెల్త్ బీమా సలహాలు <br />
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-sky-500">
                    2000 నుండి 10,000+ కుటుంబాలకు ఆర్థిక రక్షణ
                  </span>
                </>
              ) : (
                <>
                  LIC & Insurance Advisor in India <br />
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-sky-500">
                    Guiding 10,000+ Families Since 2000
                  </span>
                </>
              )}
            </h1>

            <p className="text-base md:text-lg text-slate-600 dark:text-slate-400 mb-8 max-w-2xl mx-auto leading-relaxed">
              {t('expert_advisory')}
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href={`https://wa.me/919849664800?text=${encodeURIComponent(isTe ? 'నమస్కారం వి. ఎస్. రెడ్డి గారు, నేను పాలసీ కొటేషన్ మరియు ఉచిత సలహా కోసం సంప్రదిస్తున్నాను.' : 'Hello V. S. Reddy, I am looking for expert advice on insurance and investment plans. Please connect with me.')}`}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackWhatsAppClick('hero_get_expert_advice')}
                className="w-full sm:w-auto px-8 py-4 bg-primary hover:bg-blue-600 text-white rounded-xl font-bold shadow-lg shadow-primary/30 transition-all hover:-translate-y-1 flex items-center justify-center gap-2"
              >
                {t('get_expert_advice')} <ArrowRight className="w-5 h-5" />
              </a>
              <a
                href={`tel:${ADVISOR_PHONE}`}
                onClick={() => trackPhoneClick('hero_phone_call')}
                className="w-full sm:w-auto px-8 py-4 bg-white dark:bg-slate-800 hover:bg-slate-50 dark:hover:bg-slate-700 text-slate-800 dark:text-white rounded-xl font-bold shadow-md border border-slate-200 dark:border-slate-700 transition-all hover:-translate-y-1 flex items-center justify-center gap-2"
              >
                <Phone className="w-5 h-5 text-emerald-500" /> {isTe ? `కాల్: ${ADVISOR_PHONE_DISPLAY}` : `Call ${ADVISOR_PHONE_DISPLAY}`}
              </a>
            </div>

            {/* Scrolling Claims Marquee */}
            <div className="mt-14 w-full overflow-hidden flex bg-white/40 dark:bg-slate-800/40 backdrop-blur-md border border-slate-200/50 dark:border-slate-700/50 rounded-full py-4 shadow-sm relative">
              <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-slate-50 dark:from-slate-950 to-transparent z-10 pointer-events-none"></div>
              <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-slate-50 dark:from-slate-950 to-transparent z-10 pointer-events-none"></div>

              <div className="flex animate-marquee whitespace-nowrap items-center w-max">
                {claimsData.concat(claimsData).map((claim, idx) => (
                  <div key={idx} className="flex items-center gap-3 px-8 border-r border-slate-300/50 dark:border-slate-600/50 last:border-0 shrink-0">
                    <CheckCircle2 className="w-5 h-5 text-emerald-500 shrink-0" />
                    <span className="font-bold text-slate-800 dark:text-slate-200">{claim.name}</span>
                    <span className="text-slate-500 dark:text-slate-400">|</span>
                    <span className="font-medium text-slate-600 dark:text-slate-300">{isTe ? (claim.policyTe || claim.policy) : claim.policy}</span>
                    <span className="text-slate-500 dark:text-slate-400">|</span>
                    <span className="font-extrabold text-emerald-600 dark:text-emerald-400">{isTe ? claim.amountTe : claim.amountEn}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Counters */}
      <section className="py-12 relative z-20 -mt-10">
        <div className="container mx-auto px-6">
          <div className="glass shadow-xl rounded-3xl p-8 grid grid-cols-2 md:grid-cols-4 gap-8 divide-x divide-slate-100 dark:divide-slate-800">
            <div className="text-center px-4">
              <Award className="w-6 h-6 text-primary mx-auto mb-2" />
              <div className="text-2xl font-bold text-slate-900 dark:text-white mb-1">25+</div>
              <div className="text-sm text-slate-500 font-medium">{t('years_experience')}</div>
            </div>
            <div className="text-center px-4">
              <Users className="w-6 h-6 text-sky-500 mx-auto mb-2" />
              <div className="text-2xl font-bold text-slate-900 dark:text-white mb-1">10,000+</div>
              <div className="text-sm text-slate-500 font-medium">{t('happy_families')}</div>
            </div>
            <div className="text-center px-4">
              <Shield className="w-6 h-6 text-emerald-500 mx-auto mb-2" />
              <div className="text-2xl font-bold text-slate-900 dark:text-white mb-1">100%</div>
              <div className="text-sm text-slate-500 font-medium">{t('claim_support')}</div>
            </div>
            <div className="text-center px-4">
              <Clock className="w-6 h-6 text-rose-500 mx-auto mb-2" />
              <div className="text-2xl font-bold text-slate-900 dark:text-white mb-1">24/7</div>
              <div className="text-sm text-slate-500 font-medium">{t('available_support')}</div>
            </div>
          </div>
        </div>
      </section>

      {/* Dedicated Category Hubs */}
      <section className="py-16 bg-white dark:bg-slate-900 border-y border-slate-200 dark:border-slate-800">
        <div className="container mx-auto px-6">
          <div className="text-center max-w-2xl mx-auto mb-12">
            <h2 className="text-3xl font-bold text-slate-900 dark:text-white mb-3">
              {isTe ? "లక్ష్యం ఆధారంగా బీమా పథకాలు" : "Insurance Solutions by Goal"}
            </h2>
            <p className="text-slate-500 text-sm">
              {isTe ? "మీ కుటుంబ ముఖ్యమైన మైలురాళ్లకు సరిగ్గా సరిపోయే ప్రత్యేక పాలసీల వివరాలు." : "Discover dedicated policy portfolios tailored to your specific family milestones."}
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <Link
              to="/child-insurance-plans"
              className="p-6 bg-slate-50 dark:bg-slate-800/60 rounded-3xl border border-slate-200 dark:border-slate-700/60 hover:shadow-xl hover:border-amber-300 transition-all group flex flex-col justify-between"
            >
              <div>
                <Baby className="w-10 h-10 text-amber-500 mb-4 group-hover:scale-110 transition-transform" />
                <h3 className="font-bold text-slate-900 dark:text-white text-lg mb-2">
                  {t('child_plans')}
                </h3>
                <p className="text-slate-500 text-xs leading-relaxed mb-4">
                  {isTe ? "ఎల్‌ఐసి అమృతబాల్, జీవన్ లక్ష్య మరియు జీవన్ తరుణ్. కాలేజీ చదువులు మరియు వివాహానికి గ్యారెంటీడ్ నిధి." : "LIC Amritbaal, Jeevan Lakshya & Jeevan Tarun. Guaranteed funding for university degrees and marriage."}
                </p>
              </div>
              <span className="text-xs font-bold text-primary flex items-center gap-1">
                {isTe ? "పిల్లల ప్లాన్లు చూడండి" : "Explore Child Plans"} <ArrowRight className="w-3.5 h-3.5" />
              </span>
            </Link>

            <Link
              to="/pension-retirement-plans"
              className="p-6 bg-slate-50 dark:bg-slate-800/60 rounded-3xl border border-slate-200 dark:border-slate-700/60 hover:shadow-xl hover:border-emerald-300 transition-all group flex flex-col justify-between"
            >
              <div>
                <Wallet className="w-10 h-10 text-emerald-500 mb-4 group-hover:scale-110 transition-transform" />
                <h3 className="font-bold text-slate-900 dark:text-white text-lg mb-2">
                  {t('pension_plans')}
                </h3>
                <p className="text-slate-500 text-xs leading-relaxed mb-4">
                  {isTe ? "ఎల్‌ఐసి జీవన్ ఉత్సవ్ (10% జీవితాంత ఆదాయం) మరియు న్యూ జీవన్ శాంతి గ్యారెంటీడ్ సింగిల్ ప్రీమియం పెన్షన్." : "LIC Jeevan Utsav (10% lifetime income) & New Jeevan Shanti guaranteed single premium annuities."}
                </p>
              </div>
              <span className="text-xs font-bold text-primary flex items-center gap-1">
                {isTe ? "పెన్షన్ ప్లాన్లు చూడండి" : "Explore Pension Plans"} <ArrowRight className="w-3.5 h-3.5" />
              </span>
            </Link>

            <Link
              to="/health-insurance"
              className="p-6 bg-slate-50 dark:bg-slate-800/60 rounded-3xl border border-slate-200 dark:border-slate-700/60 hover:shadow-xl hover:border-rose-300 transition-all group flex flex-col justify-between"
            >
              <div>
                <HeartPulse className="w-10 h-10 text-rose-500 mb-4 group-hover:scale-110 transition-transform" />
                <h3 className="font-bold text-slate-900 dark:text-white text-lg mb-2">
                  {t('health_plans')}
                </h3>
                <p className="text-slate-500 text-xs leading-relaxed mb-4">
                  {isTe ? "హెచ్‌డిఎఫ్‌సి ఎర్గో ఆప్టిమా సెక్యూర్ (4 రెట్ల కవరేజ్), నాన్-మెడికల్ వస్తువుల పూర్తి చెల్లింపు మరియు వృద్ధ తల్లిదండ్రుల రక్షణ." : "HDFC ERGO Optima Secure (4X Cover), Zero Consumables deduction, and dedicated senior citizen parent protection."}
                </p>
              </div>
              <span className="text-xs font-bold text-primary flex items-center gap-1">
                {isTe ? "హెల్త్ ప్లాన్లు చూడండి" : "Explore Health Plans"} <ArrowRight className="w-3.5 h-3.5" />
              </span>
            </Link>

            <Link
              to="/nri-insurance"
              className="p-6 bg-slate-50 dark:bg-slate-800/60 rounded-3xl border border-slate-200 dark:border-slate-700/60 hover:shadow-xl hover:border-orange-300 transition-all group flex flex-col justify-between"
            >
              <div>
                <Globe className="w-10 h-10 text-orange-500 mb-4 group-hover:scale-110 transition-transform" />
                <h3 className="font-bold text-slate-900 dark:text-white text-lg mb-2">
                  {t('nri_insurance')}
                </h3>
                <p className="text-slate-500 text-xs leading-relaxed mb-4">
                  {isTe ? "భారత్‌కు రాకుండానే అమెరికా, యూఏఈ, లండన్, సింగపూర్ నుండి నేరుగా ఎల్‌ఐసి పాలసీలు పొందే మెయిల్ ఆర్డర్ బిజినెస్ (MOB)." : "Mail Order Business (MOB) route for NRIs in USA, UAE, UK, Singapore, and Canada without traveling to India."}
                </p>
              </div>
              <span className="text-xs font-bold text-primary flex items-center gap-1">
                {isTe ? "ఎన్‌ఆర్‌ఐ సేవలు చూడండి" : "Explore NRI Services"} <ArrowRight className="w-3.5 h-3.5" />
              </span>
            </Link>
          </div>
        </div>
      </section>

      {/* Premium LIC Plans Section */}
      <section className="py-16 bg-white dark:bg-slate-900 relative">
        <div className="container mx-auto px-6">
          <div className="text-center max-w-2xl mx-auto mb-12">
            <h2 className="text-3xl font-bold text-slate-900 dark:text-white mb-4">{t('elite_lic')}</h2>
            <p className="text-slate-600 dark:text-slate-400 text-base">
              {t('secure_legacy')}
            </p>
          </div>

          {/* Custom Tabs */}
          <div className="flex flex-wrap justify-center gap-3 mb-12">
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setActiveCategory(cat.id)}
                className={`px-6 py-2.5 rounded-full text-sm font-semibold transition-all duration-300 ${
                  activeCategory === cat.id
                    ? 'bg-slate-900 dark:bg-white text-white dark:text-slate-900 shadow-lg scale-105'
                    : 'bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-700'
                }`}
              >
                {cat.label}
              </button>
            ))}
          </div>

          {/* Policy Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {displayLICPlans.map((plan) => (
              <div key={plan.id} className="group bg-white dark:bg-slate-800 rounded-3xl p-6 border border-slate-100 dark:border-slate-700 shadow-sm hover:shadow-2xl transition-all duration-500 relative flex flex-col justify-between">
                <div>
                  <div className="absolute top-0 right-0 p-6 opacity-10 group-hover:opacity-20 transition-opacity">
                    <Shield className="w-16 h-16 text-primary" />
                  </div>

                  <span className="inline-block px-3 py-1 bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400 rounded-full text-xs font-bold uppercase tracking-wider mb-4 w-max shadow-sm">
                    {isTe ? (plan.tagTe || plan.tag) : plan.tag}
                  </span>

                  <h3 className="text-2xl font-bold text-slate-900 dark:text-white mb-3 leading-tight">
                    {isTe ? (plan.nameTe || plan.name) : plan.name}
                  </h3>
                  <p className="text-slate-500 dark:text-slate-400 mb-6 text-sm leading-relaxed">
                    {isTe ? (plan.shortDescTe || plan.shortDesc) : plan.shortDesc}
                  </p>

                  <ul className="space-y-3 mb-8">
                    {(isTe && plan.featuresTe ? plan.featuresTe : plan.features).slice(0, 3).map((feature, idx) => (
                      <li key={idx} className="flex items-start gap-3">
                        <CheckCircle2 className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                        <span className="text-slate-700 dark:text-slate-300 text-sm font-medium">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="pt-6 border-t border-slate-100 dark:border-slate-700 flex items-center justify-between">
                  <div>
                    <div className="text-[11px] text-slate-400 font-medium">{t('monthly_prem')}</div>
                    <div className="text-base font-bold text-slate-900 dark:text-white">
                      {isTe ? (plan.premiumTe || plan.premium) : plan.premium.replace('Starting @ ', '')}
                    </div>
                  </div>
                  <Link to={`/plan/${plan.id}`} className="px-4 py-2 bg-slate-100 dark:bg-slate-700 hover:bg-primary hover:text-white text-slate-900 dark:text-white rounded-xl text-sm font-semibold transition-colors flex items-center gap-2">
                    {t('details')} <ArrowRight className="w-4 h-4" />
                  </Link>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <Link to="/lic-plans" className="inline-flex items-center gap-2 text-primary font-semibold hover:text-blue-700">
              {t('explore_all_lic')} <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </section>

      {/* HDFC ERGO Section (HEALTH ONLY) */}
      <section className="py-16 bg-slate-50 dark:bg-slate-950">
        <div className="container mx-auto px-6">
          <div className="flex flex-col lg:flex-row gap-12 items-center">
            <div className="lg:w-1/3">
              <h2 className="text-3xl font-bold text-slate-900 dark:text-white mb-4">{t('complete_health_protection')}</h2>
              <p className="text-slate-600 dark:text-slate-400 text-base mb-6">
                {t('medical_emergencies_desc')}
              </p>
              <ul className="space-y-4 mb-10">
                <li className="flex items-center gap-3"><Star className="w-6 h-6 text-yellow-500" /> <span className="font-medium text-slate-700 dark:text-slate-300">{t('cashless_hospitals_10k')}</span></li>
                <li className="flex items-center gap-3"><TrendingUp className="w-6 h-6 text-blue-500" /> <span className="font-medium text-slate-700 dark:text-slate-300">{t('no_claim_bonus_multiplier')}</span></li>
              </ul>
              <Link to="/health-insurance" className="px-8 py-4 bg-slate-900 dark:bg-white text-white dark:text-slate-900 rounded-xl font-bold hover:shadow-xl transition-all inline-flex items-center gap-2">
                {t('view_health_policies')} <ArrowRight className="w-5 h-5" />
              </Link>
            </div>

            <div className="lg:w-2/3 grid sm:grid-cols-2 gap-6">
              {hdfcPlans.slice(0, 2).map(plan => (
                <div key={plan.id} className="bg-white/60 dark:bg-slate-900/60 backdrop-blur-md rounded-3xl p-6 shadow-sm border border-slate-200 dark:border-slate-800 flex flex-col justify-between">
                  <div>
                    <span className="text-[10px] font-bold text-rose-600 dark:text-rose-400 tracking-widest uppercase mb-2 block">
                      {isTe ? (plan.tagTe || plan.tag) : plan.tag}
                    </span>
                    <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-3">
                      {isTe ? (plan.nameTe || plan.name) : plan.name}
                    </h3>
                    <div className="text-xl font-extrabold text-slate-800 dark:text-slate-200 mb-4">
                      {isTe ? (plan.coverageTe || plan.coverage) : plan.coverage} <span className="text-xs font-normal text-slate-500 block">{t('cover_amount')}</span>
                    </div>
                    <ul className="space-y-3 mb-6">
                      {(isTe && plan.featuresTe ? plan.featuresTe : plan.features).slice(0, 3).map((f, i) => (
                        <li key={i} className="flex gap-2 text-sm text-slate-600 dark:text-slate-400">
                          <CheckCircle2 className="w-4 h-4 text-emerald-500 flex-shrink-0" /> {f}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <Link to={`/plan/${plan.id}`} className="mt-4 px-4 py-2 bg-rose-50 dark:bg-rose-950/40 text-rose-700 dark:text-rose-300 hover:bg-rose-600 hover:text-white rounded-xl text-xs font-bold transition-colors inline-flex items-center justify-between">
                    <span>{t('view_plan')}</span>
                    <ArrowRight className="w-3.5 h-3.5" />
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Frequently Asked Questions */}
      <section className="py-16 bg-slate-50 dark:bg-slate-950">
        <div className="container mx-auto px-6 max-w-4xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-slate-900 dark:text-white mb-3 flex items-center justify-center gap-2">
              <HelpCircle className="w-7 h-7 text-primary" /> {isTe ? "తరచుగా అడిగే ప్రశ్నలు (FAQ)" : "Frequently Asked Questions"}
            </h2>
            <p className="text-slate-500 text-sm">
              {isTe ? "సీనియర్ అడ్వైజర్ వి. ఎస్. రెడ్డి గారి సమాధానాలు." : "Common questions answered by Senior Advisor V. S. Reddy."}
            </p>
          </div>

          <div className="space-y-4">
            {currentFaqs.map((faq, i) => (
              <div key={i} className="bg-white dark:bg-slate-900 p-6 rounded-2xl border border-slate-200 dark:border-slate-800 shadow-sm">
                <h3 className="font-bold text-slate-900 dark:text-white text-base mb-2">{faq.q}</h3>
                <p className="text-slate-600 dark:text-slate-400 text-sm leading-relaxed">{faq.a}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Outro CTA */}
      <section className="py-16 relative overflow-hidden bg-primary">
        <div className="absolute inset-0 z-0 opacity-20 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent"></div>
        <div className="container mx-auto px-6 relative z-10 text-center">
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-4">{t('expert_planning_difference')}</h2>
          <p className="text-blue-100 text-base mb-8 max-w-2xl mx-auto">{t('skip_generic')}</p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link to="/nri-calculator" className="px-8 py-3.5 bg-yellow-400 hover:bg-yellow-300 text-slate-900 rounded-full font-bold shadow-lg transition-transform hover:-translate-y-1">
              {t('try_nri_calculator')}
            </Link>
            <a
              href={`https://wa.me/919849664800?text=${encodeURIComponent(isTe ? 'నమస్కారం వి. ఎస్. రెడ్డి గారు, నేను ఇన్సూరెన్స్ ప్లానింగ్ చర్చించడానికి సంప్రదిస్తున్నాను.' : 'Hello V. S. Reddy, I would like to request a consultation callback to discuss insurance planning.')}`}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackWhatsAppClick('home_outro_cta')}
              className="px-8 py-3.5 bg-white/10 hover:bg-white/20 text-white rounded-full font-bold backdrop-blur-md border border-white/20 transition-all flex items-center justify-center gap-2"
            >
              <Phone className="w-5 h-5" /> {isTe ? "వాట్సాప్‌లో సంప్రదించండి" : "WhatsApp V. S. Reddy Now"}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
